import { render, staticRenderFns } from "./ImportCustomers.vue?vue&type=template&id=23a118bc"
import script from "./ImportCustomers.vue?vue&type=script&lang=js"
export * from "./ImportCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports